<template>
<!-- Page Content -->
<div class="container" style="padding-top: 40px;">

  <!-- Page Heading/Breadcrumbs -->

  <h1 class="mt-4 mb-3">
    {{MAINTENANCE_TITLE}}
  </h1>

    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a :href="VUE_APP_HREFHOME" class="hrefhome">Home</a>
      </li>
      <li class="breadcrumb-item active">{{MAINTENANCE_TITLE}}</li>
    </ol>

      <div class="row">
        <div class="col-lg-12 mb-12">
          <div class="card h-100">
            <h3 class="card-header">{{MAINTENANCE_SUBTITLE}}</h3>
            <div class="card-body">
              <p class="card-text">
                <span id="id_body_maintenance">&nbsp;</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    
</div>
</template>

<script>
import APIMaintenance from '@/services/api/Maintenance.js'

export default {
  name: 'Maintenance',
  props: {
    msg: String
  },
  data() {
      return {
        MAINTENANCE_TITLE:'',
        MAINTENANCE_SUBTITLE:'',
        MAINTENANCE_BODY:'',
        VUE_APP_HREFHOME: process.env.VUE_APP_HREFHOME,
      }
      },
  beforeMount(){
    var obj=this;
      APIMaintenance.getMaintenance()
      .then(function (response) {
        obj.MAINTENANCE_TITLE=response.MAINTENANCE_TITLE;
        obj.MAINTENANCE_SUBTITLE=response.MAINTENANCE_SUBTITLE;
        obj.MAINTENANCE_BODY=response.MAINTENANCE_BODY;
        document.getElementById('id_body_maintenance').innerHTML=obj.MAINTENANCE_BODY;
        })
        .catch(function(error){
          console.error(error)
        });
    } 
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
.container{
  color:red;
}
p{
  font-size: 20px;
}
</style>
